/* Bequest — theme.js (sem dependências; carregado com defer) */
(() => {
  const R = window.theme.routes;
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const define = (name, cls) => { if (!customElements.get(name)) customElements.define(name, cls); };

  function toast(msg) {
    const t = $('#Toast');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(toast.t);
    toast.t = setTimeout(() => { t.hidden = true; }, 3500);
  }

  /* ---------------- drawers (menu, busca, carrinho) ---------------- */
  class SideDrawer extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => { if (e.target.closest('[data-close]')) this.close(); });
      this.addEventListener('keyup', (e) => { if (e.key === 'Escape') this.close(); });
    }
    open(opener) {
      this.opener = opener;
      this.classList.add('is-open');
      document.body.classList.add('no-scroll');
      const focus = $('input[type="search"], [role="dialog"]', this);
      setTimeout(() => focus && focus.focus({ preventScroll: true }), 50);
    }
    close() {
      this.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
      if (this.opener) this.opener.focus({ preventScroll: true });
    }
  }
  define('side-drawer', SideDrawer);

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-open-drawer]');
    if (!btn) return;
    const d = document.getElementById(btn.dataset.openDrawer);
    if (!d) return;
    e.preventDefault();
    d.open(btn);
  });

  /* ---------------- carrinho ---------------- */
  const Cart = {
    sectionIds() {
      const ids = $$('[data-cart-section]').map((el) => el.dataset.cartSection);
      if ($('#CartDrawer')) ids.push('cart-drawer');
      return ids;
    },
    async post(url, body) {
      const r = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await r.json();
      if (!r.ok || data.status) throw new Error(data.description || data.message || window.theme.strings.cartError);
      return data;
    },
    render(sections) {
      if (!sections) return;
      Object.entries(sections).forEach(([id, html]) => {
        if (!html) return;
        const doc = parse(html);
        if (id === 'cart-drawer') {
          const inner = $('#CartDrawerInner', doc);
          const cur = $('#CartDrawerInner');
          if (inner && cur) cur.innerHTML = inner.innerHTML;
          const c = $('[data-count]', doc);
          if (c) Cart.setCount(+c.textContent);
          return;
        }
        $$(`[data-cart-section="${id}"]`).forEach((el) => {
          const fresh = $(`[data-cart-section="${id}"]`, doc);
          if (fresh) el.innerHTML = fresh.innerHTML;
        });
      });
      thresholds();
    },
    async refresh() {
      const r = await fetch(`${R.root}${R.root.endsWith('/') ? '' : '/'}?sections=${Cart.sectionIds().join(',')}`);
      Cart.render(await r.json());
    },
    setCount(n) {
      $$('[data-cart-count]').forEach((el) => { el.textContent = n; el.hidden = n === 0; });
    },
    async change(line, quantity) {
      const scope = $$('.cart-drawer__inner, [data-cart-section]');
      scope.forEach((el) => el.classList.add('cart-loading'));
      try {
        const data = await Cart.post(R.cartChange + '.js', { line, quantity, sections: Cart.sectionIds() });
        Cart.render(data.sections);
        Cart.setCount(data.item_count);
        if (data.item_count === 0 && $('[data-cart-section]')) location.reload();
      } catch (err) {
        toast(err.message);
      } finally {
        $$('.cart-loading').forEach((el) => el.classList.remove('cart-loading'));
      }
    },
  };
  window.theme.cart = Cart;

  class CartDrawer extends SideDrawer {}
  define('cart-drawer', CartDrawer);

  // barras de valor do drawer: valores em centavos da moeda da loja → moeda ativa (Shopify.currency.rate)
  function thresholds(root = document) {
    const cur = window.Shopify && window.Shopify.currency;
    const rate = cur ? +cur.rate || 1 : 1;
    if (rate === 1) return;
    let fmt;
    try { fmt = new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur.active }); } catch (_) { return; }
    $$('[data-thr]', root).forEach((el) => {
      const total = +el.dataset.total, goal = Math.round(+el.dataset.goal * rate), done = total >= goal;
      const fill = $('[data-fill]', el);
      if (fill) fill.style.width = Math.min(100, (total * 100) / goal) + '%';
      $$('[data-pending]', el).forEach((p) => { p.hidden = done; });
      $$('[data-done]', el).forEach((p) => { p.hidden = !done; });
      $$('[data-amount]', el).forEach((a) => { a.textContent = fmt.format(Math.max(0, goal - total) / 100); });
      $$('[data-pt]', el).forEach((p) => {
        const g = Math.round(+p.dataset.goal * rate);
        p.classList.toggle('is-on', total >= g);
        const a = $('[data-pt-amount]', p);
        if (a) a.textContent = fmt.format(g / 100);
      });
    });
  }
  thresholds();

  // cupom no drawer: /discount/CODE grava o código no carrinho; depois re-renderiza
  document.addEventListener('submit', async (e) => {
    const f = e.target.closest('form[data-cart-discount]');
    if (!f) return;
    e.preventDefault();
    const code = f.elements.code.value.trim();
    if (!code) { f.elements.code.focus(); return; }
    f.classList.add('cart-loading');
    try {
      const r = await fetch(`/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(R.cart + '.js')}`, { headers: { Accept: 'application/json' } });
      const c = await r.json().catch(() => ({}));
      const dc = (c.discount_codes || []).find((d) => String(d.code).toLowerCase() === code.toLowerCase());
      await Cart.refresh();
      if (dc && dc.applicable === false && f.dataset.invalid) toast(f.dataset.invalid);
    } catch (_) {
      location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(R.cart)}`;
    } finally {
      f.classList.remove('cart-loading');
    }
  });

  document.addEventListener('change', (e) => {
    const terms = e.target.closest('input[data-terms]');
    if (terms && terms.form) $$('[name="checkout"]', terms.form).forEach((b) => { b.disabled = !terms.checked; });
    const inp = e.target.closest('input[data-line]');
    if (inp) Cart.change(+inp.dataset.line, Math.max(0, parseInt(inp.value, 10) || 0));
    const note = e.target.closest('[data-cart-note]');
    if (note) fetch(R.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
    const auto = e.target.closest('form[data-autosubmit]');
    if (auto) auto.requestSubmit ? auto.requestSubmit() : auto.submit();
  });
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-remove]');
    if (rm) { e.preventDefault(); Cart.change(+rm.dataset.remove, 0); }
    const cp = e.target.closest('[data-copy]');
    if (cp && navigator.clipboard) {
      e.preventDefault();
      navigator.clipboard.writeText(cp.dataset.copy).then(() => {
        const lbl = $('[data-copy-label]', cp) || cp;
        if (!cp.dataset.copied || lbl.dataset.orig) return;
        lbl.dataset.orig = lbl.textContent;
        lbl.textContent = cp.dataset.copied;
        setTimeout(() => { lbl.textContent = lbl.dataset.orig; delete lbl.dataset.orig; }, 2000);
      });
    }
  });

  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = $('input', this);
      this.addEventListener('click', (e) => {
        const b = e.target.closest('button');
        if (!b) return;
        e.preventDefault();
        const min = +(this.input.min || 0), max = this.input.max ? +this.input.max : Infinity;
        const v = (parseInt(this.input.value, 10) || 0) + (b.name === 'plus' ? 1 : -1);
        const nv = Math.min(max, Math.max(min, v));
        if (nv === +this.input.value) return;
        this.input.value = nv;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }
  define('quantity-input', QuantityInput);

  /* ---------------- formulário de produto ---------------- */
  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.form || '') || $('form', this);
      if (!this.form || this.form.dataset.bound) return;
      this.form.dataset.bound = '1';
      this.form.addEventListener('submit', (e) => this.submit(e));
    }
    async submit(e) {
      if (window.theme.cartType === 'page' && !$('#CartDrawer')) return; // envio normal → /cart
      e.preventDefault();
      const btn = e.submitter && e.submitter.type === 'submit' ? e.submitter : $('[type="submit"]', this.form);
      if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
      const fid = this.form.getAttribute('id');
      const all = $$(`[form="${fid}"][type="submit"], #${fid} [type="submit"]`);
      all.forEach((b) => b.classList.add('is-loading'));
      const fd = new FormData(this.form);
      fd.append('sections', Cart.sectionIds().join(','));
      fd.append('sections_url', location.pathname);
      try {
        const r = await fetch(R.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
        const data = await r.json();
        if (!r.ok || data.status) throw new Error(data.description || data.message || window.theme.strings.cartError);
        if (this.dataset.skipCart === 'true') { location.href = '/checkout'; return; }
        Cart.render(data.sections);
        const drawer = $('#CartDrawer');
        if (drawer) drawer.open(btn);
        else location.href = R.cart;
      } catch (err) {
        toast(err.message);
      } finally {
        all.forEach((b) => b.classList.remove('is-loading'));
      }
    }
  }
  define('product-form', ProductForm);

  /* ---------------- seletor de variantes ---------------- */
  class VariantPicker extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse($('script[type="application/json"]', this).textContent);
      this.addEventListener('change', () => this.update());
    }
    setVariant(id) {
      const v = this.variants.find((x) => String(x.id) === String(id));
      if (!v) return;
      $$('[data-option]', this).forEach((g) => {
        const val = v.options[+g.dataset.option];
        if (g.tagName === 'SELECT') g.value = val;
        else $$('input', g).forEach((r) => { r.checked = r.value === val; });
      });
      this.update();
    }
    selected() {
      const opts = [];
      $$('[data-option]', this).forEach((g) => {
        if (g.tagName === 'SELECT') opts[+g.dataset.option] = g.value;
        else { const c = $('input:checked', g); if (c) opts[+g.dataset.option] = c.value; }
      });
      return opts;
    }
    update() {
      const opts = this.selected();
      const v = this.variants.find((x) => x.options.every((o, i) => o === opts[i]));
      $$('[data-option-label]', this).forEach((l) => { l.textContent = opts[+l.dataset.optionLabel] || ''; });
      const sec = this.dataset.section;
      const btns = $$(`[data-section-buy="${sec}"]`);
      if (!v) {
        btns.forEach((b) => { b.setAttribute('aria-disabled', 'true'); $('span', b).textContent = window.theme.strings.unavailable; });
        return;
      }
      $$(`input[name="id"][form="${this.dataset.form}"], #${this.dataset.form} input[name="id"]`).forEach((i) => { i.value = v.id; });
      if (this.dataset.updateUrl !== 'false') history.replaceState({}, '', `${this.dataset.url}?variant=${v.id}`);
      if (v.featured_media) document.dispatchEvent(new CustomEvent('variant:media', { detail: { section: sec, media: v.featured_media.id } }));
      fetch(`${this.dataset.url}?variant=${v.id}&section_id=${this.dataset.sectionId}`)
        .then((r) => r.text())
        .then((html) => {
          const doc = parse(html);
          $$(`[data-swap]`, doc).forEach((fresh) => {
            const key = fresh.dataset.swap;
            $$(`[data-swap="${key}"]`).forEach((el) => { if (!el.contains(document.activeElement)) el.innerHTML = fresh.innerHTML; });
          });
        });
    }
  }
  define('variant-picker', VariantPicker);

  /* ---------------- sliders (slideshow, anúncios, galeria) ---------------- */
  class AutoSlider extends HTMLElement {
    connectedCallback() {
      this.track = $('.slider', this);
      if (!this.track) return;
      this.slides = Array.from(this.track.children);
      this.dots = $$('[data-dot]', this);
      this.thumbs = $$('[data-thumb]', this);
      $$('[data-prev]', this).forEach((b) => b.addEventListener('click', () => this.go(this.index() - 1)));
      $$('[data-next]', this).forEach((b) => b.addEventListener('click', () => this.go(this.index() + 1)));
      this.dots.concat(this.thumbs).forEach((d) => d.addEventListener('click', () => this.go(+(d.dataset.dot || d.dataset.thumb))));
      this.track.addEventListener('scroll', debounce(() => this.mark(), 60), { passive: true });
      const sp = +this.dataset.autoplay;
      if (sp > 0 && this.slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const tick = () => {
          if (this.paused || document.hidden || this.track.scrollWidth <= this.track.clientWidth + 2) return;
          const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
          this.go(atEnd ? 0 : this.index() + 1);
        };
        this.timer = setInterval(tick, sp * 1000);
        this.addEventListener('mouseenter', () => { this.paused = true; });
        this.addEventListener('mouseleave', () => { this.paused = false; });
        this.addEventListener('focusin', () => { this.paused = true; });
      }
      this.mark();
    }
    disconnectedCallback() { clearInterval(this.timer); }
    index() {
      const w = this.slides[0] ? this.slides[0].getBoundingClientRect().width : 1;
      return Math.round(this.track.scrollLeft / Math.max(w, 1));
    }
    go(i) {
      const n = this.slides.length;
      const idx = (i + n) % n;
      const s = this.slides[idx];
      if (s) this.track.scrollTo({ left: s.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
    }
    mark() {
      const i = this.index();
      this.dots.forEach((d) => d.setAttribute('aria-current', +d.dataset.dot === i ? 'true' : 'false'));
      this.thumbs.forEach((d) => {
        const on = +d.dataset.thumb === i;
        d.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && this.thumbs.length > 1) {
          const row = d.closest('ul');
          if (row && row.scrollWidth > row.clientWidth) row.scrollTo({ left: d.parentElement.offsetLeft - row.clientWidth / 2 + d.offsetWidth / 2, behavior: 'smooth' });
        }
      });
      $$('[data-counter]', this).forEach((c) => { c.textContent = i + 1; });
    }
  }
  define('auto-slider', AutoSlider);

  class MediaGallery extends AutoSlider {
    connectedCallback() {
      super.connectedCallback();
      document.addEventListener('variant:media', (e) => {
        if (e.detail.section !== this.dataset.section) return;
        const i = this.slides.findIndex((s) => s.dataset.mediaId === String(e.detail.media));
        if (i > -1) this.go(i);
      });
    }
  }
  define('media-gallery', MediaGallery);

  /* ---------------- header ---------------- */
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      if (this.classList.contains('hdr-wrap--transparent')) {
        // header transparente sobre a 1ª seção da home: mede a altura e fica sólido ao rolar
        const h = () => document.documentElement.style.setProperty('--hdr-h', this.offsetHeight + 'px');
        h();
        if (window.ResizeObserver) new ResizeObserver(h).observe(this);
        const solid = () => this.classList.toggle('is-solid', window.scrollY > 10);
        solid();
        window.addEventListener('scroll', solid, { passive: true });
      }
      if (!this.classList.contains('hdr-wrap--on-scroll-up')) return;
      let last = 0;
      window.addEventListener('scroll', () => {
        const y = window.scrollY;
        const h = this.offsetHeight;
        if (y > last && y > h * 2) {
          this.classList.add('is-hidden');
          $$('details[open]', this).forEach((d) => d.removeAttribute('open'));
        } else if (y < last) this.classList.remove('is-hidden');
        last = y;
      }, { passive: true });
    }
  }
  define('sticky-header', StickyHeader);

  // menus suspensos: um aberto por vez, hover no desktop, fecha ao clicar fora
  const hoverOk = window.matchMedia('(hover: hover)');
  const hoverMenus = (root = document) => $$('[data-hover-menu]:not([data-hm])', root).forEach((d) => {
    d.dataset.hm = '1';
    d.addEventListener('toggle', () => { if (d.open) $$('[data-hover-menu][open]').forEach((o) => o !== d && o.removeAttribute('open')); });
    d.addEventListener('mouseenter', () => { if (hoverOk.matches) d.setAttribute('open', ''); });
    d.addEventListener('mouseleave', () => { if (hoverOk.matches) d.removeAttribute('open'); });
  });
  hoverMenus();
  document.addEventListener('shopify:section:load', (e) => hoverMenus(e.target));
  document.addEventListener('click', (e) => {
    $$('[data-hover-menu][open]').forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  /* ---------------- busca preditiva ---------------- */
  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = $('input[type="search"]', this);
      this.out = $('[data-results]', this);
      this.input.addEventListener('input', debounce(() => this.search(), 250));
    }
    async search() {
      const q = this.input.value.trim();
      if (!q) { this.out.innerHTML = ''; return; }
      this.ctrl && this.ctrl.abort();
      this.ctrl = new AbortController();
      try {
        const r = await fetch(`${R.predictiveSearch}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection,page&resources[limit]=6`, { signal: this.ctrl.signal });
        const doc = parse(await r.text());
        const res = $('#PredictiveResults', doc);
        this.out.innerHTML = res ? res.innerHTML : '';
      } catch (_) { /* abortado */ }
    }
  }
  define('predictive-search', PredictiveSearch);

  /* ---------------- barra fixa de compra ---------------- */
  class StickyAtc extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (e) => {
        const sel = e.target.closest('[data-sticky-variant]');
        if (!sel) return;
        const vp = $(`variant-picker[data-section="${this.dataset.section}"]`);
        if (vp) vp.setVariant(sel.value);
        else $$(`#${this.dataset.form} input[name="id"]`).forEach((i) => { i.value = sel.value; });
      });
      const target = document.getElementById(this.dataset.watch);
      if (!target) return;
      new IntersectionObserver(([e]) => {
        const below = e.boundingClientRect.top < 0;
        this.classList.toggle('is-visible', !e.isIntersecting && below);
      }).observe(target);
    }
  }
  define('sticky-atc', StickyAtc);

  /* ---------------- conteúdo carregado sob demanda (recomendações) ---------------- */
  class LazySection extends HTMLElement {
    connectedCallback() {
      new IntersectionObserver((entries, obs) => {
        if (!entries[0].isIntersecting) return;
        obs.disconnect();
        fetch(this.dataset.url).then((r) => r.text()).then((html) => {
          const fresh = $(`div[data-lazy-id="${this.dataset.lazyId}"]`, parse(html));
          if (fresh && fresh.innerHTML.trim()) { this.innerHTML = fresh.innerHTML; reveal(this); }
          else this.closest('.shopify-section')?.remove();
        });
      }, { rootMargin: '0px 0px 400px 0px' }).observe(this);
    }
  }
  define('lazy-section', LazySection);

  /* ---------------- barra de promoção (contagem regressiva real) ---------------- */
  class PromoTopbar extends HTMLElement {
    connectedCallback() {
      const fim = new Date(this.dataset.ends || '').getTime();
      if (isNaN(fim)) return;
      const t = $('[data-timer]', this);
      const pad = (n) => (n < 10 ? '0' : '') + n;
      const tick = () => {
        const r = Math.floor((fim - Date.now()) / 1000);
        if (r <= 0) { clearInterval(this.iv); this.closest('.shopify-section')?.remove(); return; }
        if (!t) return;
        t.hidden = false;
        $('[data-d]', t).textContent = Math.floor(r / 86400);
        $('[data-h]', t).textContent = pad(Math.floor((r % 86400) / 3600));
        $('[data-m]', t).textContent = pad(Math.floor((r % 3600) / 60));
        $('[data-s]', t).textContent = pad(r % 60);
      };
      this.iv = setInterval(tick, 1000);
      tick();
    }
    disconnectedCallback() { clearInterval(this.iv); }
  }
  define('promo-topbar', PromoTopbar);

  /* ---------------- animação de entrada ---------------- */
  const io = 'IntersectionObserver' in window && document.body.classList.contains('reveal-on')
    ? new IntersectionObserver((entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -60px 0px' })
    : null;
  function reveal(root = document) {
    $$('.reveal:not(.is-in)', root).forEach((el) => (io ? io.observe(el) : el.classList.add('is-in')));
  }
  reveal();

  /* ---------------- editor do tema ---------------- */
  document.addEventListener('shopify:section:load', (e) => { reveal(e.target); thresholds(e.target); });
  document.addEventListener('shopify:block:select', (e) => {
    const slider = e.target.closest('auto-slider, media-gallery');
    if (slider) slider.go(Array.from(slider.slides).indexOf(e.target.closest('.slider > *')));
  });
})();
